const step_CN_Locale = {
    'step.title2024': '未来已来，将至已至',
    'step.content2024_1': '入驻 GE医疗上海“创中心”',
    'step.content2024_2': '成为 GE Healthcare Global 的认证供应商',
    'step.content2024_3': '与比尔及梅琳达·盖茨基金会开展合作',
    'step.title2023': '加速',
    'step.content2023_1': '获全国首张产前智能超声医疗器械注册证，成功打造真正可用的妇幼健康一站式超声智能解决方案',
    'step.content2023_2': '超声厂家 AI授权量翻番，和行业双向奔赴、共同发展',
    'step.title2022': '启航',
    'step.content2022_1':'获全国首张婴幼儿髋关节智能超声医疗器械注册证，全面布局妇幼健康事业',
    'step.content2022_2':'获数千万 Pre-A轮融资，加速转化、乘风而上',
    'step.content2022_3':'超声厂家 AI授权破万，与经典超声行业携手共进、步入未来智能超声时代',
    'step.title2021':'扬帆',
    'step.content2021_1':'获全国首张盆底智能超声医疗器械注册证，将真正的智能科技成果代入医工盛会',
    'step.title2020':'问世',
    'step.content2020_1':'首代智能超声产品荣誉问世，开启全球化超声企业合作之路',
    'step.title2019':'扎根',
    'step.content2019_1':'公司总部落地于大湾区核心引擎城市-深圳',
    'step.content2019_2':'同年获数千万天使轮融资，蓬勃发展、向阳而生',
    'step.title2014':'深耕',
    'step.content2014_1':'首个提出“基于深度学习的超声标准切面智能定位”',
    'step.content2014_2':'首个提出“超声标准切面质量智能控制”概念',
    'step.content2014_3':'超声领域智能革新者',
    'step.title2008':'破荒',
    'step.content2008_1':'首个提出“产科超声标准切面自动识别”科研概念',
    'step.content2008_2':'智能超声领域开拓者'

}
export default step_CN_Locale
